import { AlertTooltip } from '@openx/components-core/lib/AlertTooltip/AlertTooltip.tsx';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection.tsx';
import { IndentedSections } from '@openx/components-core/lib/IndentedSection/IndentedSections.tsx';
import { RHFTextField } from '@openx/components-core/lib/TextField/RHFTextField.tsx';
import { RIGHT_COLUMN_WIDTH } from '@openx/constants/form.ts';
import { LalSegmentFields } from '@openx/types/segments.ts';
import { InfoIcon } from '@phosphor-icons/react/Info';
import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { getLalSegmentLabels } from '../../../constants.ts';
import { getLalSeedName } from '../utils/getLalSegmentsFormDefaultValues.ts';

export function DetailsSection() {
  const { t } = useTranslation();
  const observableName = useWatch({ name: LalSegmentFields.NAME });
  const { setValue } = useFormContext();

  useEffect(() => {
    setValue(LalSegmentFields.SEED_NAME, getLalSeedName(observableName, t), { shouldValidate: false });
  }, [observableName, setValue, t]);

  return (
    <FormSection divider title={t('LAL Segment Details')} rightColumnSize={RIGHT_COLUMN_WIDTH}>
      <RHFTextField
        name={LalSegmentFields.NAME}
        label={getLalSegmentLabels(t)[LalSegmentFields.NAME]}
        placeholder={t('Type your name for this LAL Segment')}
        fullWidth
        dataTest="lal-segment-name"
      />
      <IndentedSections dataTest="seed-name-section" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <RHFTextField
          name={LalSegmentFields.SEED_NAME}
          label={getLalSegmentLabels(t)[LalSegmentFields.SEED_NAME]}
          disabled
          fullWidth
          dataTest="lal-segment-seed-name"
        />
        <AlertTooltip
          placement="top"
          color="default"
          sx={{ top: 6 }}
          icon={<InfoIcon />}
          title={
            <>
              {t('Seed Segment Name Definition...')}
              <br />
              <br />
              {t('Name based on Lookalike Segment Name')}
            </>
          }
        />
      </IndentedSections>
    </FormSection>
  );
}
